import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4 20q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h16q.825 0 1.413.588T22 6v5h-2V6h-7v5h-2V6H4v12h7v2zm11.5 2q-.625 0-1.062-.437T14 20.5v-2.75h2V20h4v-2.25h2v2.75q0 .625-.437 1.063T20.5 22zm-.925-4q-.7 0-1.125-.55t-.3-1.25l.4-2q.125-.525.525-.862T15 13h6q.525 0 .925.337t.525.863l.4 2q.125.7-.3 1.25t-1.125.55zm.65-2h5.55l-.2-1h-5.15zM5 16h5v-2H5zm0-3h5v-2H5zm0-3h5V8H5zm9 0V8h5v2zM4 18V6z"
    }, null, -1)
  ]))]))
}
export default { render: render }